import i18n from '../i18n';

// API response handler
export const handleApiResponse = (response) => {
  if (!response.data) {
    throw new Error('Invalid response from server');
  }
  return response.data;
};

// API error handler
export const handleApiError = (error) => {
  const data = error.response?.data;
  return {
    success: false,
    message: data?.message || 'Something went wrong',
    errors: data?.errors || [], // validation field errors
    status: error.response?.status || 500,
  };
};

export const getApiErrorMessage = (source, fallback) => {
  const data = source?.response?.data ?? source;

  let messages = [];
  if (Array.isArray(data?.errors)) {
    messages = data.errors;
  } else if (data?.errors && typeof data.errors === 'object') {
    messages = Object.values(data.errors).flat();
  }
  messages = messages.filter(Boolean);

  if (messages.length === 1) return messages[0];
  if (messages.length > 1) {
    return (
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {messages.map((m, i) => (
          <li key={i}>{m}</li>
        ))}
      </ul>
    );
  }

  if (data?.message && data.message !== 'validation_error') {
    return i18n.exists?.(data.message) ? i18n.t(data.message) : data.message;
  }
  return fallback;
};
